var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgniteToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#6020D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3332 20C33.3332 27.3638 27.3636 33.3333 19.9998 33.3333C12.636 33.3333 6.6665 27.3638 6.6665 20C6.6665 12.6362 12.636 6.66666 19.9998 6.66666C27.3636 6.66666 33.3332 12.6362 33.3332 20ZM28.9485 20L20 11.0513L11.0515 20L20 28.9487L28.9485 20ZM15.2941 20L20 15.294L24.7059 20L20 24.706L15.2941 20Z",
    fill: "#CBAEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgniteToken);
export default __webpack_public_path__ + "static/media/IgniteToken.4fb121488f57bf8192eb83b7a760ba30.svg";
export { ForwardRef as ReactComponent };